;globalThis["_sentryRewritesTunnelPath"] = "/docs/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"uuqT692hdpRtqk_rR_RDq"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/docs";import * as Sentry from '@sentry/nextjs';

import { getGlobalArgs } from '@/root/global';

import pkg from './package.json';

const env = getGlobalArgs('NEXT_PUBLIC_ENV', 'local');

Sentry.init({
  dsn: 'https://0645435ee5d04b31bb255ff2e82277d9@sentry.sbercloud.tech/316',

  integrations: [
    Sentry.breadcrumbsIntegration(),
    Sentry.browserTracingIntegration({
      enableInp: true,
      enableLongTask: true,
    }),
  ],
  environment: env,
  tracesSampleRate: 1.0,
  debug: false,
  normalizeDepth: 8,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.2,

  ignoreErrors: [/^Minified React error #418;/, /^Minified React error #423;/, /^Error: Method not found/],

  attachStacktrace: true,
  sendDefaultPii: true,

  release: process.env.SENTRY_RELEASE,

  beforeSendTransaction(transaction) {
    transaction.tags = transaction.tags ?? {};
    transaction.tags.microservice_name = pkg.name;
    transaction.tags.namespace = getGlobalArgs('NEXT_PUBLIC_NAMESPACE');

    return transaction;
  },
});
